module.exports = __webpack_public_path__ + "static/img/f15.b2feb11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f15.png
// module id = 3hUD
// module chunks = 34